import { ModalComponent } from '@pulseops/common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { UploadDocumentDetail } from '../service-inquiry/upload-document-view'
type ViewUploadedDocumentPopupProps = {
  uploadDocVisible: boolean
  setUploadDocVisible: (value: boolean) => void
  uploadDocumentTaskId: string | undefined
  isUploadImaging?: boolean
  isLoading: boolean
}
export const ViewUploadedDocumentPopup = (props: ViewUploadedDocumentPopupProps) => {
  const { t } = useTranslation()
  const { uploadDocVisible, setUploadDocVisible, uploadDocumentTaskId, isUploadImaging, isLoading } = props
  return (
    <ModalComponent
      title={t('common:Detail')}
      visible={uploadDocVisible}
      onClose={() => {
        setUploadDocVisible(false)
        //setUploadDocumentTaskId(undefined)
      }}
      actions={[
        {
          text: t('common:Cancel'),
          type: 'filled',
          disabled: false,
          loading: isLoading,
          onlyWide: false,
          style: { height: 40 },
          action: () => {
            setUploadDocVisible(false)
            //setUploadDocumentTaskId(undefined)
          }
        }
      ]}
    >
      {uploadDocumentTaskId && <UploadDocumentDetail taskId={uploadDocumentTaskId} isUploadImaging={isUploadImaging} />}
    </ModalComponent>
  )
}